import { c as _c } from "react/compiler-runtime";
import { Tooltip, centsToUnits, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import { ContactPaymentsStatus } from 'modules/contacts/contact-page/enums/contact-payments-enum';
import { ContactPaymentsInterface } from 'modules/contacts/contact-page/types/contact-payments-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface ContactPaymentsAmountTooltipProps {
  contactPayment: ContactPaymentsInterface;
}
const ContactPaymentsAmountTooltip = t0 => {
  const $ = _c(75);
  const {
    contactPayment
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const pricePlan = contactPayment.paymentItems[0].orderItem.pricePlan;
  const productOrderItem = contactPayment.paymentItems[0].orderItem.productOrderItem;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== contactPayment.currency || $[1] !== contactPayment.status || $[2] !== contactPayment.tax || $[3] !== contactPayment.total || $[4] !== pricePlan || $[5] !== productOrderItem || $[6] !== t || $[7] !== user?.dashboardLocale) {
    const tax = centsToUnits(contactPayment.tax);
    T0 = Tooltip;
    t6 = "hover";
    t7 = "w-full max-w-fit truncate";
    t8 = "w-full";
    t3 = "flex flex-col items-start gap-2";
    let t9;
    if ($[17] !== contactPayment.currency || $[18] !== contactPayment.total || $[19] !== user?.dashboardLocale) {
      t9 = currencyFormat(centsToUnits(contactPayment.total), contactPayment.currency, user?.dashboardLocale);
      $[17] = contactPayment.currency;
      $[18] = contactPayment.total;
      $[19] = user?.dashboardLocale;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    let t10;
    if ($[21] !== t) {
      t10 = t("dashboard.contact_page.transaction_for").toLowerCase();
      $[21] = t;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    const t11 = pricePlan ? pricePlan.innerName : productOrderItem && productOrderItem.product.name;
    let t12;
    if ($[23] !== t11) {
      t12 = <span className="font-bold">{t11}</span>;
      $[23] = t11;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    if ($[25] !== t10 || $[26] !== t12 || $[27] !== t9) {
      t4 = <p>{t9}{" "}{t10}{" "}{t12}</p>;
      $[25] = t10;
      $[26] = t12;
      $[27] = t9;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    let t13;
    if ($[29] !== t) {
      t13 = t("global.status");
      $[29] = t;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    let t14;
    if ($[31] !== t13) {
      t14 = <span className="text-text-primary font-bold">{t13}: </span>;
      $[31] = t13;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    const t15 = ContactPaymentsStatus[contactPayment.status];
    let t16;
    if ($[33] !== t || $[34] !== t15) {
      t16 = t(t15);
      $[33] = t;
      $[34] = t15;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    if ($[36] !== t14 || $[37] !== t16) {
      t5 = <p>{t14}{t16}</p>;
      $[36] = t14;
      $[37] = t16;
      $[38] = t5;
    } else {
      t5 = $[38];
    }
    let t17;
    if ($[39] !== t) {
      t17 = t("dashboard.contact_page.transaction_vat");
      $[39] = t;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    if ($[41] !== t17) {
      t1 = <span className="text-text-primary font-bold">{t17}:{" "}</span>;
      $[41] = t17;
      $[42] = t1;
    } else {
      t1 = $[42];
    }
    t2 = currencyFormat(tax, contactPayment.currency, user?.dashboardLocale);
    $[0] = contactPayment.currency;
    $[1] = contactPayment.status;
    $[2] = contactPayment.tax;
    $[3] = contactPayment.total;
    $[4] = pricePlan;
    $[5] = productOrderItem;
    $[6] = t;
    $[7] = user?.dashboardLocale;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    T0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[43] !== t1 || $[44] !== t2) {
    t9 = <p>{t1}{t2}</p>;
    $[43] = t1;
    $[44] = t2;
    $[45] = t9;
  } else {
    t9 = $[45];
  }
  let t10;
  if ($[46] !== t) {
    t10 = t("dashboard.contact_page.payment_processor");
    $[46] = t;
    $[47] = t10;
  } else {
    t10 = $[47];
  }
  let t11;
  if ($[48] !== t10) {
    t11 = <span className="text-text-primary font-bold">{t10}:{" "}</span>;
    $[48] = t10;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== contactPayment.paymentProcessorName || $[51] !== tUi) {
    t12 = getPaymentProcessorTitle(contactPayment.paymentProcessorName, tUi);
    $[50] = contactPayment.paymentProcessorName;
    $[51] = tUi;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  let t13;
  if ($[53] !== t11 || $[54] !== t12) {
    t13 = <p>{t11}{t12}</p>;
    $[53] = t11;
    $[54] = t12;
    $[55] = t13;
  } else {
    t13 = $[55];
  }
  let t14;
  if ($[56] !== t13 || $[57] !== t3 || $[58] !== t4 || $[59] !== t5 || $[60] !== t9) {
    t14 = <div className={t3}>{t4}{t5}{t9}{t13}</div>;
    $[56] = t13;
    $[57] = t3;
    $[58] = t4;
    $[59] = t5;
    $[60] = t9;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== contactPayment.currency || $[63] !== contactPayment.total || $[64] !== user?.dashboardLocale) {
    t15 = currencyFormat(centsToUnits(contactPayment.total), contactPayment.currency, user?.dashboardLocale);
    $[62] = contactPayment.currency;
    $[63] = contactPayment.total;
    $[64] = user?.dashboardLocale;
    $[65] = t15;
  } else {
    t15 = $[65];
  }
  let t16;
  if ($[66] !== t15) {
    t16 = <div className="cursor-default truncate"><span>{t15}</span></div>;
    $[66] = t15;
    $[67] = t16;
  } else {
    t16 = $[67];
  }
  let t17;
  if ($[68] !== T0 || $[69] !== t14 || $[70] !== t16 || $[71] !== t6 || $[72] !== t7 || $[73] !== t8) {
    t17 = <T0 mode={t6} className={t7} wrapperClassName={t8} label={t14}>{t16}</T0>;
    $[68] = T0;
    $[69] = t14;
    $[70] = t16;
    $[71] = t6;
    $[72] = t7;
    $[73] = t8;
    $[74] = t17;
  } else {
    t17 = $[74];
  }
  return t17;
};
export default ContactPaymentsAmountTooltip;